import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LoginInputStyled from './styles/LoginInputStyled';
import DefaultInput from '../DefaultInput';
import Message from '../InputMessage';

const EMAIL_REGEX = /.+@.+\..+/i;
const NUMBER_REGEX = /^(\+?\d+)\d$/m;

const TYPE_EMAIL = 'email';
const TYPE_PHONE = 'phone';

class LoginInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
    this.checkOnlyOnUnfocused = true;
    this.isError = false;
    this.value = '';
    this.valueType = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { errorMessage: nextMessage } = nextProps;
    const { errorMessage: prevMessage } = this.props;
    if (!nextMessage && nextMessage !== prevMessage) {
      this.checkOnlyOnUnfocused = true;
    }
  }

  onChange = ({ value }) => {
    if (NUMBER_REGEX.test(value)) {
      this.valueType = TYPE_PHONE;
    } else {
      this.valueType = TYPE_EMAIL;
    }
    if (!this.checkOnlyOnUnfocused) {
      this.checkValue(value);
    }

    if (value.length === 0) {
      this.checkOnlyOnUnfocused = true;
    }
    this.value = value;
    this.props.onValueChange(value);
  };

  onFocusChange = ({ focused, value }) => {
    if (!focused && this.checkOnlyOnUnfocused && value.length > 0) {
      this.checkValue(value);
      this.checkOnlyOnUnfocused = false;
    }
    this.props.onFocusChange(focused);
  };

  checkValue = (value) => {
    let error = true;
    const { onIsErrorChange } = this.props;
    if (
      NUMBER_REGEX.test(value) ||
      EMAIL_REGEX.test(value) ||
      value.length === 0
    ) {
      error = false;
    }
    this.setState({
      error,
    });
    if (error !== this.isError) {
      this.isError = error;
      onIsErrorChange(this.isError);
    }
  };

  render() {
    const { error } = this.state;
    const { placeholder, invalidEmailFormatPhrase, errorMessage } = this.props;

    let message = '';
    if (errorMessage) {
      message = errorMessage;
    } else if (error) {
      message = invalidEmailFormatPhrase;
    }

    return (
      <LoginInputStyled>
        <DefaultInput
          {...this.props}
          isError={error || Boolean(errorMessage)}
          placeholder={placeholder}
          onChange={this.onChange}
          onFocusChange={this.onFocusChange}
        />
        <Message message={message} />
      </LoginInputStyled>
    );
  }
}

LoginInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  invalidEmailFormatPhrase: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  onIsErrorChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  onValueChange: PropTypes.func,
};

LoginInput.defaultProps = {
  errorMessage: '',
  onIsErrorChange: Function.prototype,
  onValueChange: Function.prototype,
  onFocusChange: Function.prototype,
};

export default LoginInput;
